import { useContext } from "react";
import { AuthContext } from "../useAuth";
import { useMutation } from "@tanstack/react-query";
import { endpoints, getPath } from "./apiUtils";
import axios from "axios";

export const useImagePresignUrl = () => {
  const { getAccessToken } = useContext(AuthContext);
  const path = getPath({
    endpoint: endpoints.images,
  });
  return useMutation(async ({ entityId, entityType, name, imageType }) =>
    axios
      .post(
        path,
        {
          entityType: entityType,
          entityId: entityId,
          name: name,
          imageType: imageType,
        },
        { headers: { Authorization: await getAccessToken() } }
      )
      .then((r) => r.data)
  );
};
